import { render, staticRenderFns } from "./SubMenuGroup.vue?vue&type=template&id=0d3a8680&scoped=true&"
import script from "./SubMenuGroup.vue?vue&type=script&lang=js&"
export * from "./SubMenuGroup.vue?vue&type=script&lang=js&"
import style0 from "./SubMenuGroup.vue?vue&type=style&index=0&id=0d3a8680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3a8680",
  null
  
)

export default component.exports